module.exports = __webpack_public_path__ + "img/img22.9a1d819.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img22.png
// module id = 199
// module chunks = 0